module.exports = __webpack_public_path__ + "img/AKBKTRIS.4e05c5b4.png";